/**
 * Restore the grid state and columns after export
 * @param {*} params
 */
export async function restoreGrid({
    e,
    grid,
    currentGridState,
    beforeExportColumns,
    columnNames = [],
    persistenceKey,
    // eslint-disable-next-line no-unused-vars
    storageGetter,
    finalFilterValues,
}) {
    let cols = beforeExportColumns;

    // --- 1) RESTORE COLUMNS ---
    // Hide any columns that were temporarily made visible only for export
    if (!persistenceKey) {
        const restoreVisibility = (columns) => {
            columns.forEach((item) => {
                if (item.columns && Array.isArray(item.columns)) {
                    restoreVisibility(item.columns);
                } else if (columnNames.includes(item.dataField) && !item.cellTemplate) {
                    item.visible = false;
                }
            });
        };
        restoreVisibility(cols);
    }

    try {
        e.component.option("columns", cols);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.warn("Failed to restore columns:", err);
    }

    // --- 2) RESTORE STATE (AFTER columns so state overrides export column config) ---
    if (currentGridState) {
        try {
            grid.state(currentGridState);
        } catch (err) {
            // eslint-disable-next-line no-console
            console.warn("Failed to restore captured grid state:", err);
        }
    }

    // --- 3) REAPPLY FILTER ---
    try {
        if (finalFilterValues) {
            grid.filter(finalFilterValues);
        }
    } catch (err) {
        // eslint-disable-next-line no-console
        console.warn("Failed to reapply finalFilterValues:", err);
    }

    // --- 4) FINAL REFRESH ---
    try {
        grid.repaint(true);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.warn("Repaint failed:", err);
    }
}
